import styled from "styled-components";

export const Content = styled.div<{ overflowHidden?: boolean }>`
    flex: 1 1 auto;
    z-index: 1;
    overflow: ${props => props.overflowHidden === true ? "hidden" : "initial"};
`;